import React from "react";
import { observer } from "mobx-react";
import { Button } from "../../common/button/Button";
import { ModalProps } from "../Modals";
import "./SessionExpiryWarning.css";

interface Props extends ModalProps {
  warningMinutes: number;
}

export const SessionExpiryWarning = observer(
  ({ warningMinutes, closeModal }: Props) => {
    return (
      <div role="alert">
        <p>Your session will expire in {warningMinutes} minutes</p>
        <Button onClick={closeModal} className="btn btn-success btn-extend-session">
          Extend
        </Button>
      </div>
    );
  });
